import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

export interface IRequestOptions {
	force?: boolean;
	silent?: boolean;
}

export const withRequestHandling = <T extends IRequestOptions | void = IRequestOptions | void>(options: {
	shouldFetch: () => boolean;
	setLoading: (value: boolean) => void;
}): MonoTypeOperatorFunction<T> => {
	return pipe(
		filter((params: T) => {
			const p = params;
			if (p?.force) return true;
			return options.shouldFetch();
		}),
		tap((params: T) => {
			const p = params;
			if (!p?.silent) options.setLoading(true);
		})
	);
};
